import styled from 'styled-components';
import Colors from '../../../../themes/Colors';

const ContentsOfCampaignComponent = styled.div`
  .card-inactive {
    position: relative;
  }

  .card-inactive::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    pointer-events: none;
  }
  .cardContent {
    padding: 12px 12px 8px 12px;
    gap: 7px;
    border-radius: 4px;
    width: min-content;
    min-height: 200px;
  }
  .ant-card-body {
    padding: 0px;
  }
  .icon-card {
    width: 26px;
    height: 32px;
  }
  .icon-card svg {
    font-size: 16px;
  }
  .contentCardContent {
    display: flex;
    justify-content: space-around;
    padding-top: 10px;
  }
  .textCard {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: ${Colors.black};
    margin-bottom: 0px;
  }
  .contentTitleRelation {
    display: flex;
    justify-content: space-between;
    width: 130px; /* Define de width of the card */
    margin-bottom: 10px;
  }
  .required-resolution .slick-track {
    display: flex;
    width: unset !important;
    .slick-slide {
      margin-bottom: 10px;
    }
  }
  .contentRelation > .slick-track {
    min-height: 220px;
  }
  .contentRelation > .ant-card-bordered {
    border: 0px;
  }
  .skeletonRequiredCard .ant-skeleton-title {
    display: none;
  }
  .skeletonRequiredCard .ant-skeleton-paragraph {
    margin: 0px !important;
  }
  .skeletonRequiredCard .ant-skeleton-paragraph li {
    height: 188px;
  }

  .inputVersion {
    marginbottom: 5px;
    width: 150px; /* Define de width of the card */
    font-size: 13px;
  }
  .alignImage {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    background-color: ${Colors.pureBlack};
  }
  .contentButtonCardResolution {
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
  }
  .contentCardImage {
    max-width: 115px;
    max-height: 70px;
    width: auto;
    height: auto;
    border-radius: 2px;
    object-fit: scale-down;
  }
  .contentRectangle {
    width: 134px;
    height: 70px;
    display: flex;
    justify-content: center;
  }
  .contentRectangleCardImage {
    width: 100%;
    object-fit: scale-down;
  }
  .contentCollectionCard {
    margin: 10px;
  }
  .centerCard {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .versionBadgeContainer {
    position: relative;
    width: 115px;
    height: 70px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
  }
  .imageWrapper {
    position: relative;
    display: inline-block;
    line-height: 0; // Elimina el espacio extra debajo de la imagen
  }
  .versionBadge {
    position: absolute;
    top: 0;
    right: -10px;
    transform: translate(30%, -30%);
    z-index: 2;
  }
  .copyBadge {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    margin-bottom: 4px;
  }
  .cardRed {
    background: ${Colors.tintError};
  }
  .cardRed svg {
    color: #cd2749;
  }
  .cardGreen {
    background: ${Colors.tintSuccess};
  }
  .cardGreen svg {
    color: #7cb354;
  }
  .inputContentName {
    margin-bottom: 15px;
    width: 105px;
    font-size: 13px;
    padding: 5px;
    margin-right: 5px;
  }
  .inputContentNameGroupedDisplays {
    margin-bottom: 15px;
    width: 100%;
    font-size: 13px;
    padding: 5px;
    margin-right: 5px;
  }
  .primaryCircle {
    width: 24px;
    height: 24px;
    background-color: ${Colors.primary};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: ${Colors.onPrimary};
  }
  .inputContentName::placeholder {
    font-size: 11px;
  }
  .circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background-color: #d9d9d957;
    color: ${Colors.black};
    margin-bottom: 4px;
  }
  .greenCircle {
    width: 24px;
    height: 24px;
    background-color: #7cb354;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: ${Colors.white};
    margin-bottom: 4px;
  }
  .slick-slide {
    padding-right: 5px;
    padding-left: 5px;
    width: auto !important;
    min-height: 200px;
  }
  .slick-next:before {
    color: ${Colors.textMuted};
    font-size: 28px !important;
  }
  .slick-prev:before {
    color: ${Colors.textMuted};
    font-size: 28px !important;
  }
  .slider-container {
    margin-left: 25px;
    margin-right: 20px;
  }
  .resolution-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 4px 0 8px;
  }
  .contentMessage {
    background: ${Colors.background};
    border: 1px dashed ${Colors.borderStrong};
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    margin-top: 5px;
  }
  .contentMessage p {
    margin-bottom: 0px;
    font-family: Poppins;
    font-size: 18px;
    font-weight: 300;
    line-height: 22px;
    text-align: center;
    color: ${Colors.textMuted};
  }
  .buttonContent {
    border-radius: 8px;
  }
  .resolutionHeaderRow {
    row-gap: 4px;
    margin-bottom: 8px;
  }
  .contentTolerance {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0 8px 4px;
    p {
      margin-bottom: 0;
      color: ${Colors.primaryAccent};
      white-space: nowrap;
    }
  }
  .contentToleranceInner {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  /* En pantallas angostas la tolerancia va debajo del título, alineada a la izquierda */
  @media only screen and (max-width: 991px) {
    .contentTolerance {
      justify-content: flex-start;
    }
  }
  .cardNoContent {
    border-radius: 2px;
    display: flex;
    width: 115px;
    align-items: center;
    justify-content: center;
    background: #d9d9d957;
  }
  .rectangleNoContent {
    border: 1px dashed #00000073;
    background: transparent;
  }
  .card-wrapper.multi {
    position: absolute;
    transition: transform 0.4s ease, z-index 0.3s ease;
    top: -15px;
  }
  .card-wrapper.multi:hover {
    margin-top: 4.5px;
    z-index: 99 !important;
    box-shadow: 4px 0 6px rgba(0, 0, 0, 0.1), -4px 0 6px rgba(0, 0, 0, 0.1);
    transform: scale(1.05);
  }
  .error-message-contents-displays {
    margin-bottom: 5px;
  }
  .border-orange {
    border: 2px solid ${Colors.atention};
  }
  .ant-collapse-subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
  }
  .icon-card.cardGray:hover,
  .icon-card.cardGray:focus {
    background-color: #c7bfbf;
    border-color: ${Colors.borderStrong};
  }
  .icon-card.cardGray {
    background-color: ${Colors.surfaceMuted} !important;
  }
  .icon-card.cardGray svg {
    color: #dbdbdb;
  }
`;

export default ContentsOfCampaignComponent;
